import React, { useEffect, useState } from 'react';
import { graphql, Link } from 'gatsby';
import LitImage from '../components/images/LitImage';
import GetSEOData from '../data/SEO';
import SEO from '../components/SEO';
import LitStructuredText from '../components/generic/LitStructuredText';
import BadgeHeroSection from '../components/HeroSectionBadge';
import AnyQuestions from '../components/AnyQuestions';
import ArticleGrid from '../components/ArticleGrid';
import TopStory from '../components/TopStory';
const articleContentTemplate = ({ data }) => {
  const newsPageData = data.allDatoCmsNewsArticleModel.nodes;
  const newsCategories = data.allDatoCmsNewsCategoryModel.nodes;
  const blogPageData = data.allDatoCmsBlogArticleModel.nodes;
  const blogCategories = data.allDatoCmsBlogCategoryModel.nodes;
  const articleContentData = data.datoCmsArticleContent;
  const pageSlug = articleContentData.slug;
  const { title, description } = GetSEOData(pageSlug);

  return (
    <div className="bootstrap">
      <SEO
        title={title}
        description={description}
        metaTags={articleContentData.seo}
      />{' '}
      <div className={`${articleContentData.slug}-page-container`}>
        <div className={`article-content-container`}>
          {/* PurgeCSS include: blog-page-container, news-page-container */}

          <BadgeHeroSection
            smallHeading={
              articleContentData.blogHero[0].subheading ??
              articleContentData.blogHero[0].smallHeading
            }
            heading={articleContentData.blogHero[0].heading}
            mode={articleContentData.blogHero[0].mode}
            layout={articleContentData.blogHero[0].layout}
            secondaryHeroImage={articleContentData.blogHero[0].heroImageDesktop}
            hidePostcodeSearch
            heroInnerNoPadding={articleContentData.blogHero[0].nobottompadding}
          />
          <TopStory
            topStoryTitle={articleContentData.topStoryTitle}
            topStoryIcon={articleContentData.topStoryIcon}
            title={articleContentData.topStory[0]?.title}
            previewText={articleContentData.topStory[0]?.previewText}
            publishedDate={articleContentData.topStory[0]?.publishedDate}
            slug={articleContentData.topStory[0]?.slug}
          />
          <ArticleGrid
            categories={pageSlug === 'blog' ? blogCategories : newsCategories}
            pageData={pageSlug === 'blog' ? blogPageData : newsPageData}
            pageSlug={pageSlug}
            articleGridImage={articleContentData.articleGridImage}
            articleGridSecondaryImage={
              articleContentData.articleGridSecondaryImage
            }
            backgroundColor={articleContentData.articleGridBackgroundColor}
            defaultNewsImage={data.defaultImage}
          />
          <Link to={`#${pageSlug}Container`} className="back-to-top">
            Back to top
          </Link>
          <AnyQuestions />
        </div>
      </div>
    </div>
  );
};
export default articleContentTemplate;
export const query = graphql`
  query ($id: String!) {
    datoCmsArticleContent(id: { eq: $id }) {
      seo {
        description
        title
        twitterCard
        image {
          gatsbyImageData
        }
      }
      slug
      id
      articleGridBackgroundColor
      articleGridImage {
        gatsbyImageData
      }
      articleGridSecondaryImage {
        gatsbyImageData
      }
      topStoryIcon {
        gatsbyImageData
      }
      topStoryTitle {
        value
      }
      topStory {
        ... on DatoCmsBlogArticleModel {
          previewText
          title
          publishedDate
          slug
        }
        ... on DatoCmsNewsArticleModel {
          previewText
          title
          publishedDate
          slug
        }
      }
      blogHero {
        nobottompadding
        mode
        layout
        heroImageDesktop {
          gatsbyImageData
        }
        heading {
          value
        }
        smallHeading {
          value
        }
        subheading {
          value
        }
      }
    }
    allDatoCmsBlogCategoryModel {
      nodes {
        name
      }
    }
    allDatoCmsBlogArticleModel {
      nodes {
        seoTitle
        seoDescription
        slug
        publishedDate
        previewText
        previewImage {
          gatsbyImageData(width: 300)
        }
        title
        content {
          value
        }
        category {
          name
        }
      }
    }
    allDatoCmsNewsCategoryModel {
      nodes {
        name
      }
    }
    allDatoCmsNewsArticleModel {
      nodes {
        seoTitle
        seoDescription
        slug
        publishedDate
        previewText
        previewImage {
          gatsbyImageData
        }
        title
        content {
          value
        }
        category {
          name
        }
      }
    }
    defaultImage: file(relativePath: { eq: "news-images/news_default.jpg" }) {
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
        fixed {
          src
        }
      }
    }
  }
`;
